import { render, staticRenderFns } from "./approveTable.vue?vue&type=template&id=5866e978&scoped=true"
import script from "./approveTable.vue?vue&type=script&lang=js"
export * from "./approveTable.vue?vue&type=script&lang=js"
import style0 from "./approveTable.vue?vue&type=style&index=0&id=5866e978&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5866e978",
  null
  
)

export default component.exports